import React from 'react';

import { DatasourceDownstreamOwnerIdsQuery, DatasourceDownstreamOwnerIdsQueryVariables, DownstreamOwnerIdsFilteredByFieldQuery, DownstreamOwnerIdsFilteredByFieldQueryVariables, OwnerIdFragment , DatasourceDownstreamOwnerIdsDocument , DownstreamOwnerIdsFilteredByFieldDocument } from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { DatasourceDownstreamOwnersQueryGrid } from './DatasourceDownstreamOwnersQueryGrid';

export interface DatasourceDownstreamOwnersPaneProps {
  readonly title: string;
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
  readonly datasourceLuid: string;
}

export class DatasourceDownstreamOwnersPane extends React.Component<DatasourceDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.vizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='datasource'
                      contentId={this.props.vizportalUrlId}
                      contentLuid={this.props.datasourceLuid}
                    />
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <DatasourceDownstreamOwnersQueryGrid
                  vizportalUrlId={this.props.vizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredFieldId={this.props.filteredFieldId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredFieldId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DownstreamOwnerIdsFilteredByFieldQueryVariables,
        DownstreamOwnerIdsFilteredByFieldQuery
      >({
        queryGql: DownstreamOwnerIdsFilteredByFieldDocument,
        selectConnectionListResult: (resultData) => {
          const field = resultData.fields && resultData.fields[0];
          return field.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { fieldId: this.props.filteredFieldId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DatasourceDownstreamOwnerIdsQueryVariables,
        DatasourceDownstreamOwnerIdsQuery
      >({
        queryGql: DatasourceDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const publishedDatasource = resultData.publishedDatasources && resultData.publishedDatasources[0];
          return publishedDatasource.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { datasourceVizportalUrlId: this.props.vizportalUrlId }, client);
    }
  }

}
